module.exports = __webpack_public_path__ + "img/张世平@2x.9d6b3ed2.png";